import React, { useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import { groupPagesForResults } from '../../../utils';
import PageResults from './PageResults';
import StandardPageResults from './StandardPageResults';

import styles from '../Review.module.scss';

function Results({ userGroup, assessment, userGroupAssessment }) {
  const { capabilityPages, standardPages } = useMemo(
    () => groupPagesForResults(assessment.document.pages),
    [assessment.document.pages]
  );

  return (
    <div>
      {capabilityPages.map((p) => (
        <PageResults key={p.guid} page={p} assessment={assessment} />
      ))}
      {standardPages.length > 0 && (
        <Card>
          <CardBody>
            <h3>Standard questions</h3>
            {standardPages.map((p) => (
              <div key={p.guid} className={styles['standard-page-results']}>
                <h4 className={styles['standard-page-results-title']}>
                  {p.title}
                </h4>
                <StandardPageResults page={p} />
              </div>
            ))}
          </CardBody>
        </Card>
      )}
    </div>
  );
}

export default Results;
